var activateOpenFacets = cookies => !!(cookies && cookies.get('MDM_TOOGLE_OPENFACETS'));

export default activateOpenFacets;